import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { LoaiHopDongService } from '../services/loai-hop-dong.service';

@Component({
  selector: 'app-loai-hop-dong',
  templateUrl: './loai-hop-dong.component.html',
  styleUrls: ['./loai-hop-dong.component.css']
})
export class LoaiHopDongComponent implements OnInit {
  data: any;
  loading = false;
  infoLoaiHopDongForm: FormGroup;
  totalRecords: number;
  pageSize = 10;
  pageNumber = 0;
  constructor(private loaiHopDongService: LoaiHopDongService,
    private message: MessageService, private router: Router) {
    this.totalRecords = 0;
    this.infoLoaiHopDongForm = new FormGroup({
      id: new FormControl(0),
      tenLoaiHopDong: new FormControl('', [Validators.required, Validators.minLength(4)])
    });
  }

  ngOnInit(): void {
  }

  getAllLHD() {
    this.loading = true;
    // Count
    this.loaiHopDongService.count().subscribe(
      (resp: any) => {
        if (resp != undefined) {
          this.totalRecords = resp;
          console.log(this.totalRecords);
          console.log(this.pageNumber);
          let searhValue = '';
          this.loaiHopDongService.findLoaiHopDong(searhValue, this.pageSize, this.pageNumber).subscribe(
            (res: any) => {
              this.data = res;
              this.loading = false;
            }
          );
        }
      }
    );
  }

  getLHD(event: LazyLoadEvent) {
    this.loading = true;
    event.rows

    if (event.rows != null) {
      this.pageSize = event.rows;
    }
    else {
      this.pageSize = 10;
    }
    this.loaiHopDongService.count().subscribe(
      (resp: any) => {
        if (resp != undefined) {
          this.totalRecords = resp;
          let searhValue = '';
          let pageCurrent = 0;
          if (event.first != null && event.first != undefined) {
            pageCurrent = event.first / this.pageSize;
          }
          else {
            pageCurrent = 0;
          }
          this.loaiHopDongService.findLoaiHopDong(searhValue, this.pageSize, pageCurrent).subscribe(
            (res: any) => {
              this.data = res;
              this.loading = false;
            }
          );
        }
      }
    );
  }



  saveLoaiHopDong() {
    if (this.infoLoaiHopDongForm.valid) {
      if (this.infoLoaiHopDongForm.controls.id.value != "" && this.infoLoaiHopDongForm.controls.id.value > 0) {
        this.update(this.infoLoaiHopDongForm.controls.id.value);
      }
      else {
        const dataPost = {
          tenloaihopdong: this.infoLoaiHopDongForm.controls.tenLoaiHopDong.value
        };
        this.loaiHopDongService.add(dataPost).subscribe(
          (resp: any) => {
            if (resp.id != undefined) {
              this.getAllLHD();
              this.infoLoaiHopDongForm.reset();
              this.message.add({ severity: 'success', summary: 'Thông báo', detail: 'Đã thêm thành công!' });
            }
            else {
              this.message.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi thêm!' });
            }
          }
        );
      }
    }
    else {
      this.message.add({ severity: 'error', summary: 'Thông báo', detail: 'Bạn chưa nhập đủ thông tin!' });
    }
  }

  getInfo(id: number) {
    this.loaiHopDongService.getLHDById(id).subscribe(
      (res: any) => {
        if (res != undefined) {
          this.infoLoaiHopDongForm.controls.tenLoaiHopDong.setValue(res.tenloaihopdong);
          this.infoLoaiHopDongForm.controls.id.setValue(id);
        }
      }
    );
  }

  update(id: number) {
    if (this.infoLoaiHopDongForm.valid) {
      const dataPost = {
        id: id,
        tenloaihopdong: this.infoLoaiHopDongForm.controls.tenLoaiHopDong.value
      };
      this.loaiHopDongService.update(id, dataPost).subscribe(
        (resp: any) => {
          if (resp == null) {
            this.message.add({ severity: 'success', summary: 'Thông báo', detail: 'Đã cập nhật thành công!' });
            this.infoLoaiHopDongForm.reset();
            this.getAllLHD();
          } else {
            this.message.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi cập nhật!' });
          }
        }
      );
    }
    else {
      this.message.add({ severity: 'error', summary: 'Thông báo', detail: 'Bạn chưa nhập đủ thông tin!' });
    }
  }

  delete(id: number) {
    var _al = confirm('Bạn muốn xóa bản ghi này?');
    if (_al == true) {
      this.loaiHopDongService.delete(id).subscribe(
        (resp: any) => {
          this.infoLoaiHopDongForm.reset();
          this.getAllLHD();
        }
      );
    }
  }

  resetForm() {
    this.infoLoaiHopDongForm.reset();
  }

  homeUrlNav() {
    this.router.navigate(['/home']);
  }
}
